<template>
    <div>
        <dx-grid
            url="butcherRewards"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :selectionEnabled="true"
            :actions="actions"
            ref="grid"
        ></dx-grid>

        <v-dialog v-model="sendEmailDialog" max-width="700">
            <v-card class="pa-3">
                <div class="headline">Send Email Of Unprocessed Rewards</div>
                <div v-if="!selected.length" class="my-3 text-warning">
                    Please select rewards not yet sent
                </div>

                <div v-if="selected.length" class="mb-3">
                    <div class="title pl-0 mb-2 pb-3 pt-3 text-xs-center">
                        The following rewards has been selected
                    </div>
                    <div v-for="(account, index) in selected" class="pa-2 mb-2">
                        <v-layout row>
                            <div class="width-200">
                                {{ account.date | date }}
                            </div>
                            <div class="width-250">
                                {{ account.nameH }}
                            </div>
                            <div class="width-200 font-weight-medium">
                                {{ account.amount | currency }}
                            </div></v-layout
                        >

                        <v-divider
                            class="mt-2 mb-1"
                            v-if="index + 1 < selected.length"
                        ></v-divider>
                    </div>
                </div>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="sendEmailDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        :disabled="!selected.length"
                        @click="sendEmail"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="clearRewardsDialog" max-width="700">
            <v-card class="pa-3">
                <div class="headline">Clear Processed Rewards</div>
                <div v-if="!selected.length" class="my-3 text-warning">
                    Please select rewards that was already sent
                </div>

                <div v-if="selected.length" class="mb-3">
                    <div class="title pl-0 mb-2 pb-3 pt-3 text-xs-center">
                        The following rewards will be cleared to be sent again
                    </div>
                    <div v-for="(account, index) in selected" class="pa-2 mb-2">
                        <v-layout row>
                            <div class="width-200">
                                {{ account.date | date }}
                            </div>
                            <div class="width-250">
                                {{ account.nameH }}
                            </div>
                            <div class="width-200 font-weight-medium">
                                {{ account.amount | currency }}
                            </div></v-layout
                        >

                        <v-divider
                            class="mt-2 mb-1"
                            v-if="index + 1 < selected.length"
                        ></v-divider>
                    </div>
                </div>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="clearRewardsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        :disabled="!selected.length"
                        @click="clearRewards"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Butcher Rewards",
        actions: [],
        sendEmailDialog: false,
        clearRewardsDialog: false,
        processing: false,
        selected: [],

        columns: [
            {
                field: "status",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    if (value == "SENT") {
                        return "mdi-message-text";
                    }

                    return "mdi-message-processing";
                },
                iconColor: (value, row) => {
                    if (value == "SENT") {
                        return "success";
                    }

                    return "#fdb400";
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "familyID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "month")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "Amount",
                field: "amount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Txn Type",
                field: "txnType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Redeem Type",
                field: "redeemType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Description",
                field: "description",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "AddedBy",
                field: "addedBy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date Sent To Butcher",
                field: "dateSentToButcher",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.columns.find(
            (c) => c.field == "familyID",
        ).showLink = this.showLink;

        this.actions.push({
            text: "Send Email Of Unprocessed Rewards",
            action: this.openSendEmail,
            showOnSelection: true,
        });

        this.actions.push({
            text: "Clear Rewards Sent",
            action: this.openClearRewards,
            showOnSelection: true,
        });
    },
    methods: {
        async onRowClicked(row) {
            this.$router.push({
                name: "Account View",
                params: {
                    id: row.accountID,
                },
                query: {
                    goToSiteVisitSection: true,
                },
            });
        },
        openSendEmail() {
            const selected = this.$refs.grid.getSelectedRowsData();

            this.selected = selected.filter((s) => !s.dateSentToButcher);

            this.sendEmailDialog = true;
        },
        openClearRewards() {
            const selected = this.$refs.grid.getSelectedRowsData();

            this.selected = selected.filter((s) => s.dateSentToButcher);

            this.clearRewardsDialog = true;
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        async sendEmail() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/butcherRewards/sendEmail",
                    this.selected,
                );

                this.processing = false;
                this.sendEmailDialog = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async clearRewards() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/butcherRewards/Save",
                    this.selected.map((reward) => {
                        reward.dateSentToButcher = null;

                        return reward;
                    }),
                );

                this.processing = false;
                this.clearRewardsDialog = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
